// eslint-disable-next-line monorepo/no-internal-import
import {createSharedStore} from '@aboutyou/storage/src/sharedStore';

export const useGlobalFetchTokenState = createSharedStore<{
  wishlistToken: number;
  updateWishlistToken: () => void;
}>(set => ({
  wishlistToken: 0,
  updateWishlistToken: () => {
    set(state => ({...state, wishlistToken: state.wishlistToken + 1}));
  },
}));

export const notifyWishlistUpdate = () => {
  useGlobalFetchTokenState.getState().updateWishlistToken();
};
